<template>
	<div id="season-form">
    <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>Duel</li>
      <li>
        <router-link :to="{path: '/register-liga'}">List Register Liga</router-link>
      </li>
      <li class="active">{{ !$route.query.id ? 'Buat' : 'Update' }} Register Liga</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{ !$route.query.id ? 'Buat' : 'Update' }} Register Liga</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">{{ !$route.query.id ? 'Buat' : 'Update' }} Register Liga</h4>
          </div>
          <div class="panel-body">
						<div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" :key="key">{{message}}</li>
              </ul>
            </div>

						<!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
								<div class="form-group">
									<label class="col-md-2 control-label">Nama Register Liga</label>
									<div class="col-md-8 col-xs-12">
										<input type="text" class="form-control" v-model="data.name">
									</div>
								</div>

								<div class="form-group">
									<label class="col-md-2 control-label">Deskripsi</label>
									<div class="col-md-8 col-xs-12">
										<app-editor 
											:rows="8" 
											:value="data.description" 
											:context="data.description"
											v-on:content-updated="data.description = $event" 
										/>
									</div>
								</div>
							</div>
            </form>
						<hr />
						<div class="pull-right">
							<button v-if="!$route.query.id" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
							<button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
					</div>
				</div>
			</div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import DuelService from '@/services/duel.js'
import Spinner from '@/components/plugins/Spinner'
import Moment from 'moment'
import MarkdownEditor from '@/components/plugins/MarkdownEditor'

export default {
	name: 'season-form',
	components: {
		'app-spinner': Spinner,
		'app-editor': MarkdownEditor,
	},
	data: function () {
		return {
			queryId: null,
			errors: [],
			isLoading: false,
			selectedPicture: null,
			data: {
				name: null,
				description: null,
			},
		}
	},
}
</script>


// WEBPACK FOOTER //
// RegisterLigaForm.vue?fe4e7644